import { AuthenService } from './../../services/authen.service';
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, CanActivateChild } from "@angular/router";
import { Observable } from "rxjs/Rx";
import { TranslateService } from '@ngx-translate/core';
import { PermissionService } from '../../services/permission.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
    currentUser: any;
    currentLanguage: string;
    constructor(private _router: Router,
        public _authService: AuthenService,
        public translate: TranslateService,
        public _permissionService: PermissionService) {
        this.setLanguage();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        this.currentUser = JSON.parse(localStorage.getItem('currentUser'));


        let URlRedirect = state.url;
        if (state.url) {
            if (state.url.indexOf('?') > -1) {
                URlRedirect = state.url.split('?')[0];
            }
        }
        console.log("URlRedirect", URlRedirect);


        if (this.currentUser) {
            // return this._authService.verify().map(data => {
            return true;
            // });

            // return this._authService.verify().map(
            //     data => {
            //         if (data) {
            //             console.log(data);
            //             // logged in so return true
            //             return true;
            //         }
            //         // error when verify so redirect to login page with the return url
            //         this._router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
            //         return false;
            //     },
            //     error => {
            //         // error when verify so redirect to login page with the return url
            //         this._router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
            //         return false;
            //     });


        } else {
            this._router.navigate(['/auth/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
        return true;
    }

    setLanguage() {
        this.currentLanguage = localStorage.getItem('Language');
        if (this.currentLanguage !== null && this.currentLanguage !== '') {
            this.translate.use(this.currentLanguage);
        } else {
            this.translate.use('en');
        }
    }

    checkCanAccessUrl = (url: string): boolean => {
        return this._permissionService.CheckCanAccessURL(url);
    }

}


// WEBPACK FOOTER //
// ./src/app/guard/_guards/auth.guard.ts